import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_certificate_upload",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "certificate_upload",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_certificate_upload_button",
  "data-kt-drawer-close": "#kt_drawer_certificate_upload_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_certificate_upload",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header bg-primary text-light",
  id: "kt_certificate_upload_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-light my-auto" }, " Upload Income Certificate "),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-sm btn-icon btn-active-primary-light me-n5",
      id: "kt_drawer_certificate_upload_close"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
    ])
  ])
], -1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_certificate_upload_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_certificate_upload_body",
  "data-kt-scroll-dependencies": "#kt_certificate_upload_header, #kt_certificate_upload_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = ["validation-schema"]
const _hoisted_6 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_certificate_upload_scroll"
}
const _hoisted_7 = { class: "row my-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "col-md-12 mt-5 text-center" }
const _hoisted_10 = ["data-kt-indicator"]
const _hoisted_11 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, { class: "form" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock("div", {
              class: "position-relative",
              key: _ctx.componentkey
            }, [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Field, {
                        type: "file",
                        name: "certificate",
                        class: "form-control form-control",
                        accept: "image/jpeg",
                        modelValue: _ctx.certificate,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.certificate) = $event)),
                        onChange: this.certificateStatus
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        "data-kt-indicator": _ctx.loading ? 'on' : null,
                        class: "btn btn-lg btn-success",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.certificateUpload()))
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createTextVNode(" Please wait... "),
                              _hoisted_12
                            ]))
                          : _createCommentVNode("", true),
                        _createTextVNode(" > "),
                        _hoisted_13,
                        _createTextVNode(" Upload ")
                      ], 8, _hoisted_10)
                    ])
                  ])
                ])
              ], 8, _hoisted_5)
            ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}